module.exports = __webpack_public_path__ + "img/PGR_A05_back_en.7fa679fc.png";